export const toastKey = Symbol("gnexus-ui-kit-toast");
